import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
// import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Select, MenuItem, Autocomplete, Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import DownloadIcon from "@mui/icons-material/Download";
import { CustomPagination } from "../../../SecondaryFunctions";
import isAuthenticated from "../../../../components/Utils/isAuthenticated";
import { useSTDUsriSearchQuery } from "../../../../Hooks/useSTDUsriSearchQuery";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import { fetchSTDUSRIResults } from "../../../../components/Api/Getters";
import { getUSRIReportData } from "../../../../components/Api/Getters";
import ReportDialog from "./ReportDialog";
const ref_options = {
	C: "All Courses",
	CS: "All Courses Similar Class Size",
	CL: "All Courses Similar Course Level",
	CSL: "All Courses Similar Course Level/Class Size",
	F: "Courses in Faculty",
	FS: "Courses in Faculty Similar Class Size",
	FL: "Courses in Faculty Similar Course Level",
	FSL: "Courses in Faculty Similar Course Level/Class Size",
	D: "Courses in Department",
	DS: "Course in Department Similar Class Size",
	DL: "Courses in Department Similar Class Level",
	DSL: "Courses in Department Similar Class Level/Class Size",
};

export default function SearchUsriResults() {
	// Define various state variables using the useState hook
	const auth = isAuthenticated();
	const token = auth.token;
	const [loadingBar, setLoadingBar] = useState(true); // To show/hide loading bar
	const [filteredCourseData, setFilteredCourseData] = useState([]); // Store filtered course data
	const [openReportDialog, setOpenReportDialog] = useState(false);
	const [reportData, setReportData] = useState([]);
	const [terms, setTerms] = useState([]);
	const [insts, setInsts] = useState([]);
	const [selectedTerms, setSelectedTerms] = useState([]);
	const [subject, setSubject] = useState("");
	const [catalogue, setCatalogue] = useState("");
	const [instName, setInstName] = useState("");
	const [subjectError, setSubjectError] = useState(false);
	// const [nameError, setNameError] = useState(false);
	const [courseSelected, setCourseSelected] = useState(false);
	const [empid, setEmpid] = useState("");
	const [openSearch, setOpenSearch] = useState(false);
	// const [isError, setIsError] = useState(false);
	const [loadingReports, setLoadingReports] = useState(false);
	const [hasSearched, setHasSearched] = useState(false);

	useEffect(() => {
		if (subject.length > 0 || catalogue.length > 0) {
			setCourseSelected(true);
		} else {
			setCourseSelected(false);
		}
	}, [subject, catalogue]);

	function getEMPID(name) {
		const employee = insts.find((item) => item.name === name);
		return employee ? employee.empid : "?";
	}

	const { data: allSearchParams, isFetched } = useSTDUsriSearchQuery(token);

	useEffect(() => {
		if (isFetched) {
			setLoadingBar(false);
			let data = allSearchParams;
			let term_info = [];

			let inst_info = [];

			const terms = data.terms;

			const insts = data.faculty_rank;
			terms.forEach((term) => {
				const termObj = {
					term: term.term,
					season: term.desc_term.split(" ")[0],
					year: term.desc_term.split(" ")[1],
					desc_term: term.desc_term.concat(" (", term.term, ")"),
				};
				term_info.push(termObj);
			});

			insts.forEach((inst) => {
				inst_info.push({
					empid: inst.empid,
					name: inst.name,
					unit: inst.unit,
					label: inst.name,
				});
			});
			setTerms(term_info.sort((a, b) => b.term - a.term));

			setInsts(
				inst_info.sort((a, b) =>
					a.name.trim().split(", ")[0].localeCompare(b.name.trim().split(", ")[0]),
				),
			);
		}
	}, [isFetched, allSearchParams]);

	const handleTermChange = (event, newValue) => {
		if (newValue.length > 0) {
			const selections = newValue.map((termObj) => {
				const matchingObject = terms.find((obj) => obj.desc_term === termObj.desc_term);
				return matchingObject ? matchingObject.term : null;
			});
			setSelectedTerms(selections);
		} else {
			setSelectedTerms([]);
		}
	};
	async function searchReports() {
		setHasSearched(true);
		if (selectedTerms.length > 0 && (subject.length > 1 || instName.length > 1)) {
			try {
				setLoadingReports(true);
				setSubjectError(false);
				// setIsError(false);

				const data = await fetchSTDUSRIResults(
					token,
					selectedTerms.join(","),
					empid === "?" ? "None" : empid,
					subject.length > 0 ? subject.concat(" ", catalogue) : "None",
				);

				setFilteredCourseData(data);
				setLoadingReports(false);
			} catch (error) {
				setLoadingReports(false);
				// setIsError(true);
			}
		} else {
			setLoadingReports(false);
			// setIsError(true);
		}
	}

	const handleOpenReportDialog = async (row) => {
		const index = filteredCourseData.findIndex((r) => r.id === row.id);
		const newRows = [...filteredCourseData];
		newRows[index].loading = true;
		setFilteredCourseData(newRows);
		const data = await getUSRIReportData(
			token,
			[String(row.reqnum).concat("-").concat(String(row.clsnum)).concat("-").concat(row.ref_group)],
			"pub",
			"view",
		);
		setReportData(data.data);

		setOpenReportDialog(true);
		const newRows2 = [...filteredCourseData];
		newRows2[index].loading = false;
		setFilteredCourseData(newRows2);
	};

	const columns = [
		{
			field: "course",
			headerName: "Course",
			flex: 0.25,
			headerAlign: "center",
			renderCell: (params) => (
				<div className="flex items-center justify-center h-full">{params.value}</div>
			),
		},
		{
			field: "description",
			headerName: "Description",
			flex: 0.175,
			headerAlign: "center",
			renderCell: (params) => (
				<div className="flex items-center justify-center h-full">{params.value}</div>
			),
		},
		{
			field: "term",
			headerName: "Term",
			flex: 0.1,
			headerAlign: "center",
			renderCell: (params) => (
				<div className="flex items-center justify-center h-full">{params.value}</div>
			),
		},
		{
			field: "name",
			headerName: "Instructor",
			flex: 0.15,
			headerAlign: "center",
			renderCell: (params) => (
				<div className="flex items-center justify-center h-full">{params.value}</div>
			),
		},
		{
			field: "refgroup",
			headerName: "Reference Group",
			flex: 0.2,
			headerAlign: "center",
			renderCell: (params) => (
				<Select
					sx={{
						overflow: "hidden",
						fontSize: "0.875rem",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",

						marginY: "4px",
					}}
					variant="outlined"
					value={params.row.ref_group}
					onChange={(e) => {
						const rowsCopy = [...filteredCourseData];
						const index = rowsCopy.findIndex((row) => row.id === params.row.id);
						const value = e.target.value;
						rowsCopy[index].ref_group = value;
						setFilteredCourseData(rowsCopy);
					}}
				>
					{/* onChange={setRefGroup(index,value)}> */}
					<MenuItem value={params.row.ref1}>{ref_options[params.row.ref1]}</MenuItem>
					{params.row.ref2 !== "" && (
						<MenuItem value={params.row.ref2}>{ref_options[params.row.ref2]}</MenuItem>
					)}
					{params.row.ref3 !== "" && (
						<MenuItem value={params.row.ref3}>{ref_options[params.row.ref3]}</MenuItem>
					)}
				</Select>
			),
		},
		{
			field: "view",
			headerName: "Report",
			flex: 0.1,
			headerAlign: "center",

			renderCell: (params) => (
				<div
					onClick={() => handleOpenReportDialog(params.row)}
					disabled={params.row.loading}
					className="w-full h-full  p-2"
				>
					<button
						onClick={() => handleOpenReportDialog(params.row)}
						disabled={params.row.loading}
						className="bg-primary text-white px-4 py-2 h-full  rounded-md hover:ring-2 hover:bg-green-900 flex items-center justify-center disabled:bg-gray-400 disabled:cursor-not-allowed mx-auto "
					>
						{params.row.loading ? (
							<CircularProgress size={20} className="" />
						) : (
							<>
								{" "}
								<DownloadIcon />
								View
							</>
						)}
					</button>
				</div>
			),
		},
	];

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				height: "100vh",
				maxHeight: `calc(100vh - calc(13rem + 8px))`,
				backgroundColor: "#F5F5F5"
			}}
			// className="border-t"
		>
			<ReportDialog
				open={openReportDialog}
				setOpen={setOpenReportDialog}
				reportData={reportData}
				reportType="pub"
			/>
			<Box
				sx={{
					width: "21%",
					maxWidth: 400,
					// height:'auto',
					// borderRight: "2px solid rgba(0, 0, 0, .5)",
					// borderColor: "rgba(0, 0, 0, 0.2)",
					paddingRight: "10px",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div className="flex flex-col space-y-6 w-full rounded-md py-2 px-2 mb-2">
					{/* STEP 1 */}
					<div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
						{/* icon container */}
						<div
							className={`flex-shrink-0 ${
								selectedTerms.length === 0 ? "text-yellow-600" : "text-primary"
							}`}
						>
							{/* responsive icon sizing */}
							<LooksOneIcon className="w-6 h-6 sm:w-12 sm:h-12" />
						</div>

						{/* Autocomplete: flex‑1 + min-w-0 allows it to shrink below its content width */}
						<div className="flex-1 min-w-0">
							<Autocomplete
								sx={{backgroundColor:'#FFF'}}
								freeSolo
								multiple
								limitTags={3}
								onChange={handleTermChange}
								size="small"
								options={terms.sort((a, b) => b.term - a.term)}
								getOptionLabel={(o) => o.desc_term}
								disableCloseOnSelect
								fullWidth
								renderInput={(params) => (
									<TextField
										{...params}
										label="SELECT TERM(S) (REQUIRED)"
										required
										InputProps={{
											...params.InputProps,
											endAdornment: (
												<>
													{loadingBar && <CircularProgress color="inherit" size={20} />}
													{params.InputProps.endAdornment}
												</>
											),
										}}
									/>
								)}
							/>
						</div>
					</div>

					{/* STEP 2 */}
					<div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
						<div
							className={`flex-shrink-0 ${
								selectedTerms.length === 0
									? "text-gray-200"
									: subject || catalogue || (empid && empid !== "?")
										? "text-primary"
										: "text-yellow-600"
							}`}
						>
							<LooksTwoIcon className="w-6 h-6 sm:w-12 sm:h-12" />
						</div>

						<div className="flex-1 min-w-0 flex flex-col gap-4">
							{/* subject/catalogue inputs stack on xs, sit side‑by‑side on sm+ */}
							<div className="flex flex-col sm:flex-row gap-2 w-full" >
								<TextField
									className="w-full sm:w-1/2"
									disabled={(empid && empid !== "?") || !selectedTerms.length}
									sx={{
											"& .MuiOutlinedInput-root": {
												backgroundColor: "#FFF", // default (enabled)
											},
  										}}
									label="Subject"
									helperText="ex: 'MATH'"
									size="small"
									value={subject}
									onChange={(e) =>
										setSubject(e.target.value.replace(/[^A-Za-z]/g, "").toUpperCase())
									}
								/>
								<TextField
									className="w-full sm:w-1/2"
									disabled={(empid && empid !== "?") || !selectedTerms.length}
									sx={{
											"& .MuiOutlinedInput-root": {
												backgroundColor: "#FFF", // default (enabled)
											},
  										}}
									label="Catalogue #"
									helperText="ex: '100'"
									size="small"
									value={catalogue}
									onChange={(e) => setCatalogue(e.target.value.replace(/\D/g, ""))}
								/>
							</div>
							{subjectError && (
								<p className="text-red-500 text-center">Please fill out the subject field.</p>
							)}

							<Divider className="w-full" orientation="horizontal">
								OR
							</Divider>

							<div className="w-full">
								<Autocomplete
									// sx={{backgroundColor:'#FFF'}}
									className="w-full"
									disabled={subject || catalogue || !selectedTerms.length}
									sx={{
											"& .MuiOutlinedInput-root": {
												backgroundColor: "#FFF", // default (enabled)
											},
  										}}
									freeSolo
									open={openSearch}
									options={[...new Set(insts.map((i) => i.name))]}
									ListboxProps={{
										style: { maxHeight: 200, overflowY: "auto" },
									}}
									onInputChange={(e, v) => setOpenSearch(v.length >= 3)}
									onChange={(e, v) => {
										setInstName(v);
										setEmpid(getEMPID(v));
										setOpenSearch(false);
									}}
									filterOptions={(options, { inputValue }) => {
										const trimmedInput = inputValue.trim();

										if (trimmedInput.includes(" ")) {
											const tokens = trimmedInput.split(/\s+/).map((token) => token.toLowerCase());
											return options.filter((option) => {
												const parts = option.split(",").map((part) => part.trim().toLowerCase());

												return tokens.every((token) => parts.some((part) => part.includes(token)));
											});
										} else {
											const normalizedInput = trimmedInput.replace(/,/g, "").toLowerCase();
											return options.filter((option) =>
												option.replace(/,/g, "").toLowerCase().trim().includes(normalizedInput),
											);
										}
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Instructor Name"
											helperText="ex: 'John Doe'"
											size="small"
											value={instName}
											onChange={(e) => setInstName(e.target.value)}
										/>
									)}
								/>
							</div>
							{/* {nameError && (
								<p className="text-red-500 text-center">
									Please fill out the Instructor field.
								</p>
							)} */}
						</div>
					</div>

					{/* STEP 3 */}
					<div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
						<div
							className={`flex-shrink-0 ${
								!selectedTerms.length || (!courseSelected && (!empid || empid === "?"))
									? "text-gray-200"
									: "text-primary"
							}`}
						>
							<Looks3Icon className="w-6 h-6 sm:w-12 sm:h-12" />
						</div>
						<div className="flex-1 min-w-0">
							<Button
								fullWidth
								disabled={!selectedTerms.length || (!courseSelected && (!empid || empid === "?"))}
								variant="contained"
								sx={{ backgroundColor: "#275d38", fontSize: 16 }}
								onClick={searchReports}
							>
								{loadingReports ? (
									<CircularProgress size={28} sx={{ color: "white" }} />
								) : (
									"Search Reports"
								)}
							</Button>
						</div>
					</div>
				</div>
			</Box>
			<div className="p-2 w-[79%] flex flex-col h-[75dvh] relative ">
				{!hasSearched && (
					<div className="absolute top-1/2 left-1/2  w-full h-full z-20 bg-black bg-opacity-30 transform -translate-x-1/2 -translate-y-1/2">
						<div className=" w-full h-full flex flex-col items-center justify-center">
							<div className="bg-primary rounded-md w-[30dvw] h-auto p-12 text-primaryGold">
								<p className="text-left text-lg font-semibold">
									Begin searching for historical USRI Reports by selecting your desired term(s) on
									the left hand side of the screen and entering the course name ("MATH 100" subject
									= MATH, catalogue # = 100) and/or selecting an instructor.
								</p>
							</div>
						</div>
					</div>
				)}

				<DataGrid
					getRowHeight={() => "auto"}
					disableColumnFilter
					disableColumnSelector
					disableColumnMenu
					disableSelectionOnClick
					loading={loadingReports}
					getRowId={(row) => row.id}
					columns={columns}
					rows={filteredCourseData}
					density={"compact"}
					pageSize={100}
					rowsPerPageOptions={[100]}
					slots={{
						Pagination: CustomPagination,

						LoadingOverlay: CircularProgress,
					}}
					//loading={loadingBar}
					sx={{
						height: "82dvh",
						width: "100%",

						"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
							outline: "None !important",
						},
						"& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
							width: "0.4em",
						},
						"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
							background: "#f1f1f1",
						},
						"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
							backgroundColor: "#888",
						},
						"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
							background: "#555",
						},
					}}
				/>
			</div>
		</div>
	);
}
